import styled from 'styled-components';

const DesktopBarStyled = styled.div`
display: flex;
justify-content: space-between;
.leftSide {
display: flex;
align-items: center;
}
.leftSide img {
    margin-right: 15px;
    }
.leftSide a {
    margin-right: 15px;
        }
  `

export default DesktopBarStyled;
